exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.types .type[data-v-e0a9b380]{display:none;width:38px;height:38px\n}\n.types .type.active[data-v-e0a9b380]{display:block\n}\n", ""]);

// exports
